<template>
  <article class="cr-card">
    <div class="cr-card__info">
      <div class="cr-card__header">
        <span class="cr-card__num">#{{ item.ticketNumber }}</span>
        <span class="cr-card__sep" aria-hidden="true">·</span>
        <span class="cr-card__date">{{ formattedDate }}</span>
      </div>
      <span class="cr-card__title">{{ item.cf_short_title }}</span>
      <div class="cr-card__meta">
        <template v-if="item.cf_asset_type">
          <strong class="cr-card__asset">{{ $t('ticketsList.default.' + item.cf_asset_type) }}</strong>
        </template>
        <template v-if="item.cf_sold_solution">
          <span v-if="item.cf_asset_type" class="cr-card__sep" aria-hidden="true">–</span>
          <span class="cr-card__solution">{{ item.cf_sold_solution }}</span>
        </template>
      </div>
    </div>
    <div class="cr-card__actions">
      <TicketStatus :status="item.statusType" />
      <router-link
        class="btn-details"
        :to="`/${url}/${$t('nav.detail')}/${item.ticketNumber}`"
      >
        {{ $t('tickets.details') }}
        <span class="material-icons" aria-hidden="true">arrow_forward</span>
      </router-link>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import TicketStatus from '@/components/Feature/Ticket/TicketStatus.vue'

const { locale } = useI18n()

const props = defineProps({
  item: { type: Object, required: true },
  url: { type: String, required: true },
})

const formattedDate = computed(() =>
  moment(props.item.createdTime).format('DD-MM-YYYY', locale.value, true)
)
</script>

<style scoped>
/* $grayFive=#e1e7ec  $bluFour=#002e5f  $textGray=#5f6b7a  $graySeven=#b8c4ce
   $white=#ffffff  $fontMiddle=1rem  $fontNormal=1.125rem  $font20=1.25rem */
.cr-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: #ffffff; /* $white */
  border: 1px solid #e1e7ec; /* $grayFive */
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 46, 95, 0.06); /* rgba($bluFour, 0.06) — ombra lieve */
  padding: 16px 20px;
  margin-bottom: 8px;
}

.cr-card__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

/* Riga 1: #id · data */
.cr-card__header {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem; /* $font14 */
  color: #5f6b7a; /* $textGray */
  font-family: OpenSansRegular;
}

.cr-card__num {
  font-family: OpenSansSemiBold;
}

.cr-card__date {
  font-family: OpenSansRegular;
}

/* Riga 2: titolo */
.cr-card__title {
  font-size: 1.125rem; /* $fontNormal */
  color: #002e5f; /* $bluFour */
  font-family: OpenSansBold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Riga 3: asset type (bold) – soluzione */
.cr-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 1rem; /* $fontMiddle */
  color: #5f6b7a; /* $textGray */
  font-family: OpenSansRegular;
}

.cr-card__asset {
  font-family: OpenSansBold;
  color: #5f6b7a; /* $textGray */
}

.cr-card__sep {
  color: #b8c4ce; /* $graySeven */
}

.cr-card__actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

/* Layout a colonna su mobile — body.mobile = width < 1400px (pattern di progetto) */
:global(body.mobile) .cr-card {
  flex-direction: column;
  align-items: flex-start;
}

:global(body.mobile) .cr-card__actions {
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
</style>
